import { Box, type SxProps, type Theme } from '@mui/material';
import type { EntityIcon } from '@wedding/shared';
import EntityIconMark from './icons/EntityIconMark';

export default function NameText({
  name,
  icon = null,
  sx,
}: {
  name: string;
  icon?: EntityIcon | null;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      component="span"
      sx={[
        {
          display: 'inline-flex',
          alignItems: 'flex-start',
          gap: 0.75,
          maxWidth: '100%',
          textAlign: 'inherit',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <EntityIconMark icon={icon} />
      <Box component="span" sx={{ whiteSpace: 'pre-line', minWidth: 0 }}>{name}</Box>
    </Box>
  );
}
